import * as React from "react"
import type { SVGProps } from "react"

export default function PeaceOfMind({ ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" {...props}>
      <path
        d="M445.59 143.07S365.19 27.31 264.81 15C176.2 4.19 94 46.56 82.5 138.13c-4.08 32.62-11.34 68.71-24.24 98.48C43.79 270 19.1 297.78 38 362s98.77 122.12 156.82 122 112.59-53 157.58-101 188.26-93 93.19-239.93Z"
        style={{
          fill: "#5b4eb9",
        }}
      />
      <path
        d="M445.59 143.07S365.19 27.31 264.81 15C176.2 4.19 94 46.56 82.5 138.13c-4.08 32.62-11.34 68.71-24.24 98.48C43.79 270 19.1 297.78 38 362s98.77 122.12 156.82 122 112.59-53 157.58-101 188.26-93 93.19-239.93Z"
        style={{
          fill: "#fff",
          opacity: 0.7000000000000001,
        }}
      />
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <path
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
          d="M80.02 54.64h171.87V271.4H80.02z"
        />
        <path
          d="M80 225.67a263.13 263.13 0 0 1 51.21-46.87c41-28.78 87.66-42.92 120.66-64.32M80 171.26c25.52-14.42 56.29-34.31 80.68-57.69 27.14-26 34.38-46 35.19-58.93M125 271.4c17-37.91 49.29-103.44 57.46-74.35 6.25 22.3-3 52.23-12.38 74.35M123.33 54.64c-13.68 14.8-27.46 34.7-13.85 44.19 18.32 12.77 42.34-15.75 54.71-44.19"
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
        />
        <circle
          cx={215.06}
          cy={91.46}
          r={22.1}
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
        />
        <circle
          cx={104.22}
          cy={127.94}
          r={11.57}
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
        />
        <circle
          cx={116.13}
          cy={228.73}
          r={18}
          transform="rotate(-13.04 116.128 228.712)"
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
        />
      </g>
      <path
        d="M109.74 429.47c-6-101 32.72-170.85 33.11-171.55l2.15 1.28c-.39.69-38.75 69.95-32.81 170.22Z"
        style={{
          fill: "#9e9e9e",
        }}
      />
      <path
        d="M108.93 421.23c-4.47-75.43 7.77-175.13 7.89-176.13l2.46.4c-.13 1-12.34 100.48-7.88 175.69Z"
        style={{
          fill: "#9e9e9e",
        }}
      />
      <path
        d="M104.14 418.94c-4.31-39.94-3.51-67.83-2.07-84.19 1.56-17.81 4.11-26 4.22-26.37l2.36.83c-.1.33-10.24 33.66-2.05 109.57ZM113.32 399.28l-2.46-.35c6.62-64.84.37-96.2.3-96.51l2.42-.41c.07.31 6.42 31.99-.26 97.27Z"
        style={{
          fill: "#9e9e9e",
        }}
      />
      <path
        d="m116.33 415.22-2.47-.24c2.42-42.44-6.27-65.1-6.36-65.32l2.29-.82c.37.93 8.99 23.33 6.54 66.38Z"
        style={{
          fill: "#9e9e9e",
        }}
      />
      <path
        d="M117.09 256.35a119.81 119.81 0 0 1-13.23-36.21c-3.65-20.23 3.69-36.22 13.17-46.1s24.71-16.93 33.79-24.92S174 129.83 174 129.83s-5.43 28.22-5.32 54.09-14.8 40.92-25.76 48.92-25.83 23.51-25.83 23.51Z"
        style={{
          fill: "#5b4eb9",
        }}
      />
      <path
        d="M142.62 260.91S136.31 233 155.26 228s23.71 4.87 28.41 5.55 11.82 1.46 17 7 4.38 9.23 8.05 12.53 7.18 5.13 8.71 11.74 4 13.46 1.2 17.57c0 0-7.83-20.64-25.91-24.6s-46.4 1.64-50.1 3.12ZM110.94 290.22s-2.91-25.4-8.15-38.57-21.73-25.4-32.74-30.1S50.93 214 48.4 209.79s-7.89-8.94-6 1.88 4 28.22 9.45 35.75l5.48 7.52s19.75 0 31 11.29 23.35 30.57 23.35 30.57Z"
        style={{
          fill: "#5b4eb9",
        }}
      />
      <path
        d="M111.68 296.8s-21.12-22.1-31.31-29.63-23.39-8.46-30.95-9.4-15.59-13.17-15.59-13.17 5.85 28.22 14 43.27 29.29 14.58 40.58 14.58 23.27-5.65 23.27-5.65Z"
        style={{
          fill: "#5b4eb9",
        }}
      />
      <path
        d="M104.85 313.74s1-11.29 6.83-16.94 16.29-4.23 23-1.88 9.78-2.35 15-.94 13 6.59 17.86 11.29 11.56 18.34 11.66 20.7-10.73-9.41-18.86-12.7-23.23-4.27-33.58-4.27-21.91 4.74-21.91 4.74ZM109.86 344.31s-2.78-10.31-11.38-13.64-20.77-1.88-24.48-1.88-10.54-4.71-18.25 2.35a38.16 38.16 0 0 0-10.21 15.05 33.93 33.93 0 0 1 21.32-8c12.69 0 17.83-.94 24.63 4.24s20.71 13.17 20.71 13.17Z"
        style={{
          fill: "#5b4eb9",
        }}
      />
      <path
        d="M113.64 379.35s1.84-24 5.8-30.57 18.09-17.88 25-22.11 17.08-8 17.08-8a91.86 91.86 0 0 1-9.77 26.33c-7.46 13.17-25.89 22.58-28 27.76a55.33 55.33 0 0 0-2.92 8.93s-.7-5.64 11.92-7.52 23.57 1.41 28 6.11 10.28 9.88 11.69 9.88 10.6 6.11 10.6 6.11-6.94 2.82-17.41 0-19.57-7-26.15-7-19.66 2.35-19.66 2.35 20.83 3.29 24.2 5.17 15.35 7.53 15.35 7.53-15 .94-22.85 4.7-11.38 9.41-11.75 11.76-.69 6.12-.69 6.12l.28 7.05h-31s.21-17.87-9-25.4-23.84-8-23.84-8l-9.75 3.29s2.15-5.18 10.91-9.41 15.25-6.58 20.43-6.58a34.35 34.35 0 0 1 8.5.94s-9.32-9.41-19.22-9.88-23.02 3.26-24.39 4.2 24.31-15.05 32.8-14.58a30 30 0 0 1 14.79 5.18L90 365.24s4-4.7 13.84 4.7Z"
        style={{
          fill: "#5b4eb9",
        }}
      />
      <g
        style={{
          opacity: 0.2,
        }}
      >
        <path
          d="M153.34 163c3-4.54 5.17-7.43 5.17-7.43M119.28 245.5s10.51-29.64 16.18-48.07c3-9.87 9.43-21.17 14.71-29.53"
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
        />
        <path
          d="M144.68 220.83s-7.09 5.31-16 12-7.45 4.61-7.45 4.61l-8.15-14.18M122 204.16c2.13 5.68 5.67 17 5.67 17L150.35 207M150.88 188.36l8.69-5.11M130.15 175.8l5.31 21.63 11.09-6.52M194.1 245.08a11.77 11.77 0 0 1 3.41 2c4.25 3.55 2.13 3.9 8.51 8.16s14.86 20.13 12.57 27.26M181.55 236.43a7.47 7.47 0 0 0 3.55 6 12.6 12.6 0 0 0 4.15 1.42M63 234c-4.33-4.12-6.91-6.8-6.91-6.8M96.55 269.43c-4-6.23-10.23-15-17.81-21.3-4.5-3.77-8.59-7.42-12-10.58M101.07 277.2s-.83-1.64-2.36-4.23M87.6 256.64l-13.83-23.76M71.65 242.81l-12.06-3.55M75.31 287.37a49.75 49.75 0 0 1-6.85-3.08c-8.51-5-18.8-12.05-22-16.31M106.75 297.05s-15-3.94-26.8-8"
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
        />
        <path
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
          d="m52.5 283.94 15.95.35-7.44-10.99M72 292.8l17.02-1.06-9.22-12.77M146.15 300.58c.85.43 1.88.91 3.14 1.44 6.74 2.83 7.09.35 13.47 4.61s7.8 8.5 11 12.05M142.2 297.76s.16.65 2.36 1.95M142.21 338.94a51.81 51.81 0 0 0 4.95-6.43M117 368.32s10-15.25 18.11-22.32c.85-.74 1.66-1.48 2.42-2.2"
        />
      </g>
      <path
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
        d="M486.11 433.91H18.94"
      />
      <path
        d="M453.41 280.16H338.17a5.68 5.68 0 0 0-5.7 4.3L301 433.91h127.1l31-147.45c.7-3.27-2.04-6.3-5.69-6.3Z"
        style={{
          fill: "#949494",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M309.53 177.82s-14.84 10-14 17.53 8.9 13.76 8.9 13.76 11.06-26.7 11.87-27-6.77-4.29-6.77-4.29ZM302.72 241.13s2.56 11.72.73 17.58l-1.83 5.86s16.84 5.12 22.34 2.19 6.22-4.76 6.22-4.76-21.24-23.8-27.46-20.87ZM299.9 298.62s29.06-2 43.59 0 16.28 2.38 16.28 2.38-12.79 44.46-20.93 61.9-26.73 32.25-26.73 32.25-28.78-49.45-12.21-96.53Z"
        style={{
          fill: "#263238",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M312.76 180.25s-8.9 19.42-9.71 23.73-.27 12.68-.27 15.92-2.69 14.83-2.69 17.8 11.32 26.43 14.29 27.5 6.74-.53 6.74-.53 1.35 10 1.08 12.19-7 5.13-7 5.13-8.9 17.53-7 23.73 8.9 12.14 21.57 10.52 18.61-5.67 22.12-16.18 6.2-21 6.2-21-4 .48-4-4.11.27-26.43.27-26.43 3.77-37.75-7.83-53.13-29.72-22.39-33.77-15.14Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M307.64 177.28s22.92 23.47 30.74 36.95.81 51.51 3.78 51.51 13-.29 36.23-11.35 22.66-32.63 17-48.27-19.51-34-31.91-40.16-46.67-8.63-55.84 11.32Z"
        style={{
          fill: "#263238",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M344.71 221.39c4.3 8.79 12.71 27.74 11.26 38.79M342.3 216.66s.36.67 1 1.85M381.14 241.08a20.5 20.5 0 0 1 .36 7.95M317.48 178.18s-5 2.87 32 27.33c19.14 12.63 27.05 23.44 30.22 31.14"
        style={{
          fill: "none",
          stroke: "#b2b2b2",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M322.47 221a9.2 9.2 0 0 0 10 1.08M304.94 220.43s2.16 2.7 5.93.27M310.34 210.73s2.69 6.47 2.69 9.44a10.54 10.54 0 0 1-1.35 5.12M308.72 238.23a14.42 14.42 0 0 0 4.31 2.43M311.41 245s8.9 4 15.11-.81M319.24 210.73s11.32-3.51 15.64 3.23M304.4 209.11s2.7-2.16 4.32-.27"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        style={{
          fill: "#263238",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
        d="m321.12 264.67 12.68-2.7-11.87 10.52-.81-7.82z"
      />
      <path
        d="M322.07 278.35a2 2 0 1 1-2-2 2 2 0 0 1 2 2Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M321.53 281.72a2 2 0 1 1-2-2 2 2 0 0 1 2 2Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M321 285.09a2 2 0 1 1-2-2 2 2 0 0 1 2 2ZM357.91 277a2 2 0 1 1-2-2 2 2 0 0 1 2 2Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M356 279a2 2 0 1 1-2-2 2 2 0 0 1 2 2Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <circle
        cx={351.82}
        cy={281.22}
        r={2.02}
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M351.44 283.4a2 2 0 1 1-2-2 2 2 0 0 1 2 2Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M348.91 285.47a2 2 0 1 1-2-2 2 2 0 0 1 2 2Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <circle
        cx={343.91}
        cy={287.88}
        r={2.02}
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M343.52 289.76a2 2 0 1 1-2-2 2 2 0 0 1 2 2Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M340.65 292.47a2 2 0 1 1-2-2 2 2 0 0 1 2 2Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M337.71 294.19a2 2 0 1 1-2-2 2 2 0 0 1 2 2Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M334.5 296a2 2 0 1 1-2-2 2 2 0 0 1 2 2ZM320.69 289a2 2 0 1 1-2-2 2 2 0 0 1 2 2Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <circle
        cx={319.01}
        cy={292.35}
        r={2.02}
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M321.78 295.55a2 2 0 1 1-2-2 2 2 0 0 1 2 2Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <circle
        cx={322.34}
        cy={297.63}
        r={2.02}
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M331.13 297.29a2 2 0 1 1-2-2 2 2 0 0 1 2 2Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M328 298.32a2 2 0 1 1-2-2 2 2 0 0 1 2 2Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M357.91 277s-9.2 30.46-14.59 44.41-19.65 44.69-19.65 44.69-13.31-18.38-15.53-40.89 7.05-43.2 7.05-43.2-24.46 8.41-30.48 10.63-12.87 5.41-15.4 11.43-30.82 85.89-32.09 89.06-3.8 3.49-.31 8.88 20.28 5.7 23.45 2.85S281.83 375 281.83 375l6.66 13 2.85 39.3-.63 6.66H376l-1-23.14s31.72-79.86 34.26-93.49-1.27-20.92-7-25S357.91 277 357.91 277Z"
        style={{
          fill: "#5b4eb9",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M303.84 301.1a2.9 2.9 0 0 0-3.52 1.87c-.93 2.58-1.64 4.93-1.64 4.93s-3.28 4.7-4 7-2.58 21.12-3.05 22.77-2.11 10.09-2.11 10.09l-2.58 4 6.8 11.73s3.76-.23 7.28-5.63 3.52-4.93 4.22-11.73 1.41-43.89 1.41-43.89-1.4-1.61-2.81-1.14Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M317.69 360s-.7-4.93.47-6.57 3.52-1.88 4-7.27-1.17-10.57-.23-16.43 3.52-4.7 3.28-7.28-4-3.05-5.16-1.17-2.35 4.22-2.35 4.22-.94-15-1.41-19.95-3.75-6.33-3.75-6.33-1.41-4-3.29-3.05-2.11 2.11-2.11 2.11a9 9 0 0 0-3.29 2.82 8.64 8.64 0 0 0-.7 4.22 11.44 11.44 0 0 0-3.05 4.69c-.7 2.59-3.52 19.25-3.76 25.82s0 18.07 1.18 20.18 4.22 6.57 4.22 6.57l1.88 5.64s8.91-7.28 14.07-8.22Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M303.14 305.32s1.41.7 1.17 4-1.87 18.31-1.87 18.31M307.13 298.28s1.87-1.1 1.4 3-.46 24.49-.46 24.49M312.53 299.22s.94 19 .47 24.41M317.69 325.5s1.14 6.9 1.6 8.54"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="m287.55 348.78 10.14 13.71s-21.82 33.22-25.23 38.64-14.45 18.1-20.67 19.7-9.63 0-13-4.81-8.43-13-6.22-18.47 18.86-21.11 24.08-23.92 30.9-24.85 30.9-24.85ZM395.36 291.54s5 .4 6.94.7 5.51 5.12 6.91 8.13 1.41 14.45.8 20.87-13.82 54.43-16.63 69.28-12.46 37-14.26 39.59-5.22 5-8.63 4.81-24.57-14.93-32.4-22.55-37.74-47-37.74-47 3.82-6 7.23-8 10.64-3.21 10.64-3.21S331.46 365.6 341.7 374a155.55 155.55 0 0 0 20.3 14.08s4.42-25.58 5-28.59 5.35-28.89 5.35-28.89"
        style={{
          fill: "#5b4eb9",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M362 388.08s7.23 2.81 9 13.45M362.37 390.69s4.22 3 3.22 9.63M276.87 356.77a26.3 26.3 0 0 1 1-14.45c2.81-7.63 9-28.91 9-28.91"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <path
          d="M437.75 179.67c17 10.87 8.18 19.68-2.69 2.69-10.86 17-19.67 8.18-2.68-2.69-17-10.86-8.18-19.67 2.68-2.68 10.87-16.99 19.67-8.18 2.69 2.68Z"
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
        />
        <path
          d="M437 177.78c19.69-4.33 19.69 8.12 0 3.79 4.33 19.7-8.12 19.7-3.79 0-19.7 4.33-19.7-8.12 0-3.79-4.37-19.7 8.08-19.7 3.79 0Z"
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
        />
      </g>
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <path
          d="M303.42 128c11.25 7.19 5.41 13-1.78 1.78-7.19 11.25-13 5.41-1.78-1.78-11.25-7.19-5.41-13 1.78-1.78 7.19-11.22 13.03-5.4 1.78 1.78Z"
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
        />
        <circle
          cx={301.64}
          cy={128.01}
          r={1.78}
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
        />
      </g>
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <circle
          cx={238.8}
          cy={322.85}
          r={1.78}
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
        />
        <path
          d="M240.06 321.6c13-2.87 13 5.38 0 2.51 2.87 13-5.38 13-2.51 0-13.05 2.87-13.05-5.38 0-2.51-2.87-13.04 5.38-13.04 2.51 0Z"
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
        />
      </g>
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <circle
          cx={405.51}
          cy={255.45}
          r={1.78}
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
        />
        <circle
          cx={405.51}
          cy={255.45}
          r={1.78}
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
        />
      </g>
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <path
          d="M238.12 182.8c18.07 11.56 8.7 20.92-2.86 2.85-11.56 18.07-20.93 8.71-2.85-2.85-18.08-11.56-8.71-20.93 2.85-2.86 11.56-18.07 20.93-8.7 2.86 2.86Z"
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
        />
        <circle
          cx={235.26}
          cy={182.8}
          r={2.85}
          style={{
            fill: "none",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
        />
      </g>
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <circle
          cx={398.85}
          cy={105.69}
          r={48.26}
          transform="rotate(-74.66 398.85 105.69)"
          style={{
            fill: "none",
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
        <circle
          cx={398.85}
          cy={105.69}
          r={42.49}
          transform="rotate(-21.9 398.815 105.687)"
          style={{
            fill: "none",
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
        <path
          d="M401.81 105.69a3 3 0 1 1-3-3 3 3 0 0 1 3 3ZM402 104.81l10.28-3.21M398.85 108.65v30.86"
          style={{
            fill: "none",
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
      </g>
      <path
        d="m244.08 453.66 61.18-15.41c.95-.23 1.31-3.14.34-3.14l-90.25 1.52Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="m244.08 452.11 61.18-15.41a.82.82 0 0 0-.2-1.62h-89.71Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        style={{
          fill: "#949494",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
        d="M237.91 440.56h30.88l-34.4 7.04 3.52-7.04z"
      />
      <path
        d="M244.08 453.66h-139l-16-82.53a4.85 4.85 0 0 1 4.76-5.77H223a4.84 4.84 0 0 1 4.75 3.93Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M241.9 453.66H103l-16-82.53a4.85 4.85 0 0 1 4.75-5.77h129.04a4.85 4.85 0 0 1 4.76 3.93Z"
        style={{
          fill: "#c2c2c2",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <circle
        cx={159.14}
        cy={410.43}
        r={10.14}
        style={{
          fill: "#999",
        }}
      />
      <path
        d="M439.92 409.9s5.37-2.83 8-.8 4.49 7.48 4.49 12.41-2 9.86-5.51 12.19-9.87.58-9.87.58l.29-4.94s4.94 2 7.84-1.74 1.16-11-.58-12.76-5.8 2.32-5.8 2.32Z"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
        d="M442.45 401.53h-37.67l3.77 46.56h30.14l3.76-46.56z"
      />
      <path
        d="M413.89 368.91c0 7.29-4 7.29-4 14.58s4 7.3 4 14.59M421.61 377.56a12.65 12.65 0 0 0-1.28 5.93c0 7.3 4 7.3 4 14.59M424.33 368.91a12.82 12.82 0 0 1-.92 5.13M431.74 388.74c1.19 2.8 3 4.38 3 9.34M434.78 368.91c0 7.29-4 7.29-4 14.58"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
    </svg>
  )
}
